<template>
  <div class="ajax-form">
    <input type="hidden" name="category" value="1">
    <div class="row">
      <div class="col-12">
        <div class="page__head-title page__head-title--orange">
          <div class="page__head-title__text page__head-title__text--orange">Assistance Autocars</div>
          <div class="page__head-title__notice">(* champs obligatoires)</div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form_ttl">Informations Assistance Autocars</div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Nom de l'assuré</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.name_of_signatory" class="input_n" :class="{input_red_shadow: hasError('name_of_signatory')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Numéro RCS</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.rcs" maxlength="9" class="input_n" :class="{input_red_shadow: hasError('rcs')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Nom du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.nom" class="input_n" :class="{input_red_shadow: hasError('nom')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Prénom du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.prenom" class="input_n" :class="{input_red_shadow: hasError('prenom')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Adresse du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.adresse" class="input_n" :class="{input_red_shadow: hasError('adresse')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Code postal</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.cp" maxlength="5" class="input_n" :class="{input_red_shadow: hasError('cp')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Ville</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.ville" class="input_n" :class="{input_red_shadow: hasError('ville')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Téléphone du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.tel" maxlength="10" class="input_n" :class="{input_red_shadow: hasError('tel')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Email du signataire</div>
          <div class="form__item__input-wrapper">
            <input type="email" v-model="assistanceAutocar.email" class="input_n" :class="{input_red_shadow: hasError('email')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Date d'effet</div>
          <div class="form__item__input-wrapper form__item__input-wrapper--date currency-datepicker">
            <CustomDatepicker :date.sync="effectiveDateInput" :has-error="hasError('effective_date')"/>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form_ttl">Information sur l'assistance :</div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Nombre de véhicules à assister</div>
          <div class="form__item__input-wrapper">
            <input type="text" v-model="assistanceAutocar.nb_vehicles" maxlength="3" class="input_n" :class="{input_red_shadow: hasError('nb_vehicles')}">
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item">
          <div class="form__item__label form__item__label--required">Options</div>
          <div class="form__item__input-wrapper form__item__input-wrapper">
            <select v-model="assistanceAutocar.option" name="option" id="option" class="select_n"
                    :disabled="searchVehicleFilled"
                    :class="{input_red_shadow: hasError('option')}"
            >
              <option value="0">Choisir une option...</option>
              <option value="1">Aucune</option>
              <option value="2">Dépannage/remorquage avec prise en charge à concurrence de 2500 € TTC</option>
              <option value="3">Dépannage/remorquage avec prise en charge à concurrence de 4000 € TTC</option>
              <option value="4">Véhicule de remplacement max 3 jours à concurrence de 500€ TTC/jour</option>
              <option value="5">Dépannage/remorquage avec prise en charge à concurrence de 2500 € TTC et Véhicule de remplacement max 3 jours à concurrence de 500€ TTC/jour</option>
              <option value="6">Dépannage/remorquage avec prise en charge à concurrence de 4000 € TTC et Véhicule de remplacement max 3 jours à concurrence de 500€ TTC/jour</option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="form__item justify-content-center mt-3 mb-3">
          <div class="form__item__submit">
            <Preloader v-if="isSending"/>
            <input v-else type="submit" name="Submit" value="Voir le devis" class="form_bt btnSendAjax form_confirm_button form__item__submit__button btn btn-block" @click="onSubmit">
          </div>
        </div>
      </div>
    </div>
    <ValidationErrors :errorsList="errors"/>
  </div>
</template>

<script>
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import garantieFieldsLists from '@/mixins/garantieFieldsLists';
    import Preloader from '@/components/Preloader'
    import {DEBOUNCE} from "@/mixins/helper";
    import {TheMask} from 'vue-the-mask'
    import CustomDatepicker from '@/components/CustomInputs/CustomDatepicker';
    import CustomTextInput from "../DealerInsuranceCampingCar/CustomTextInput";
    import CustomRadioInput from "../DealerInsuranceCampingCar/CustomRadioInput";

    const INITIAL_FIELDS_VALUES = Object.freeze({
        civilite: 3,
        name_of_signatory: '',
        rcs: '',
        nom: '',
        prenom: '',
        adresse: '',
        cp: '',
        ville: '',
        tel: '',
        // fax: '',
        email: '',
        nb_vehicles: '',
        jour_prise_effet: '',
        mois_prise_effet: '',
        annee_prise_effet: '',
        jour_vente: 1,
        mois_vente: 1,
        annee_vente: new Date().getFullYear(),
        type: 1,
        // jour_livraison: 1,
        // mois_livraison: 1,
        // annee_livraison: new Date().getFullYear()
    });

    const CAR_TYPE_VP = 1;
    const CAR_TYPE_VU = 2;
    const CAR_TYPE_4X4 = 3;

    const CIVILITY_M = 0;
    const CIVILITY_MLLE = 1;
    const CIVILITY_MME = 2;
    const CIVILITY_SOCIETY = 3;

    export default {
        name: 'BrokerAssistanceAutocar',
        components: {ValidationErrors, Preloader, TheMask, CustomDatepicker, CustomTextInput, CustomRadioInput},
        mixins: [garantieFieldsLists],
        data() {
            return {
                assistanceAutocar: {...INITIAL_FIELDS_VALUES},
                errors: {},
                isSending: false,
                searchResult: null,
                isClientSearching: false,
                effectiveDateInput: '',
                shippingDateInput: '',
                circulationDateInput: '',
                birstdayDateInput: '',
                isVehicleSearching: false,
                searchVehicleResult: null,
                acceptedVehicleResult: false,
            }
        },
        computed: {
            isEditAssistance() {
                return !!this.$route.params.id
            },
            existingCustomerFound() {
                return !!this.searchResult;
            },
            existingVehicleFound() {
                return !!this.searchVehicleResult;
            },
            // isNewCar() {
            //     return this.assistanceAutocar.is_new === 'Oui';
            // },
            mechanic_id() {
              return this.$store.state.userInfo.mechanic ? this.$store.state.userInfo.mechanic.id : '';
            },
        },
        watch: {
        },
        methods: {
            searchClient: DEBOUNCE(function (val) {

                if (this.assistanceAutocar.tel.length > 2) {
                    let url = 'client/searchOne',
                        data = {
                            tel: this.assistanceAutocar.tel
                        };
                    this.isClientSearching = true;
                    this.apiGet(url, data, false)
                    .then(response => {
                        if (response.data.client) {
                            this.searchResult = response.data.client;
                        }

                        this.isClientSearching = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.isClientSearching = false;
                    })
                }
            }, 1000),
            serializeData() {
                this.assistanceAutocar.mechanic_id = this.mechanic_id;
                return this.assistanceAutocar;
            },
            onSubmit(event) {
                this.validateEffectiveDate();
                this.isSending = true;
                let url = 'garantie/assistance-autocar',
                    data = this.serializeData();
                if (this.isEditAssistance) {
                    url = 'garantie/assistance-autocar/' + this.$route.params.id + '/edit';
                }
                this.apiPostFormData(url, data).then((response) => {
                    this.isSending = false;
                    this.errors = {};
                    if (response.data.calcQuotes)
                        this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                    this.showSuccessNotification(response.data.message, '');
                    let id = response.data.quote.id;
                    this.$router.push('/assistance-autocars-view/' + id);
                }).catch(error => {
                    this.isSending = false;
                    this.errors = error.response.data;

                    if (error.response.data.exception === 'App\\Exceptions\\PriceErrorException') {
                        this.errors.errors = {};
                        this.errors.errors.error = [error.response.data.message];
                    }
                })
            },
            getGuarantyInfo() {
                let url = 'garantie/assistance-autocar/' + this.$route.params.id;
                this.apiGet(url).then(response => {
                    this.assistanceAutocar = this.parseQuoteData(response.data.quote);
                }).catch(error => {
                    console.log(error)
                })
            },
            parseClientInfo(client) {
                this.assistanceAutocar.name_of_signatory = client.name_of_signatory;
                this.assistanceAutocar.rcs = client.rcs;
                this.assistanceAutocar.nom = client.last_name;
                this.assistanceAutocar.prenom = client.first_name;
                this.assistanceAutocar.adresse = client.address;
                this.assistanceAutocar.cp = client.zip;
                this.assistanceAutocar.ville = client.city;
                this.assistanceAutocar.tel = client.tel;
                this.assistanceAutocar.email = client.email;
                this.assistanceAutocar.id_client = client.id;
            },
            parseQuoteData(quote) {
                let parsedQuote = {};

                if (quote.client && quote.client.id) {
                    parsedQuote.name_of_signatory = quote.client.name_of_signatory;
                    parsedQuote.rcs = quote.client.rcs;
                    parsedQuote.nom = quote.client.last_name;
                    parsedQuote.prenom = quote.client.first_name;
                    parsedQuote.adresse = quote.client.address;
                    parsedQuote.cp = quote.client.zip;
                    parsedQuote.ville = quote.client.city;
                    parsedQuote.tel = quote.client.tel;
                    parsedQuote.email = quote.client.email;
                    parsedQuote.id_client = quote.client.id;
                }

                if (quote.details) {
                    // if (quote.details.datesParse) {
                    //     let effective_day = quote.details.datesParse.day_effective,
                    //         effective_month = quote.details.datesParse.month_effective - 1,
                    //         effective_year = quote.details.datesParse.year_effective;
                    //     parsedQuote.jour_prise_effet = effective_day;
                    //     parsedQuote.mois_prise_effet = effective_month;
                    //     parsedQuote.annee_prise_effet = effective_year;
                    //
                    //     this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                    //
                    //     parsedQuote.jour_vente = quote.details.datesParse.day_sale;
                    //     parsedQuote.mois_vente = quote.details.datesParse.month_sale;
                    //     parsedQuote.annee_vente = quote.details.datesParse.year_sale;
                    //
                    //     parsedQuote.jour_livraison = quote.details.datesParse.day_delivery;
                    //     parsedQuote.mois_livraison = quote.details.datesParse.month_delivery;
                    //     parsedQuote.annee_livraison = quote.details.datesParse.year_delivery;
                    // }

                  // alert(quote.effective_date);
                  let effective_day = quote.datesParse.day_effective,
                    effective_month = quote.datesParse.month_effective - 1,
                    effective_year = quote.datesParse.year_effective;
                  // alert(effective_day);
                  parsedQuote.jour_prise_effet = effective_day;
                  // alert(parsedQuote.jour_prise_effet);
                  parsedQuote.mois_prise_effet = effective_month;
                  parsedQuote.annee_prise_effet = effective_year;

                  this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);
                    if (quote.nb_vehicles_base) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_base;
                      parsedQuote.option = 1;
                    }
                    else if (quote.nb_vehicles_option1) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_option1;
                      parsedQuote.option = 2;
                    }
                    else if (quote.nb_vehicles_option2) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_option2;
                      parsedQuote.option = 3;
                    }
                    else if (quote.nb_vehicles_option3) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_option3;
                      parsedQuote.option = 4;
                    }
                    else if (quote.nb_vehicles_option4) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_option4;
                      parsedQuote.option = 5;
                    }
                    else if (quote.nb_vehicles_option5) {
                      parsedQuote.nb_vehicles = quote.nb_vehicles_option5;
                      parsedQuote.option = 6;
                    }

                    parsedQuote.shipping_date = this.moment(quote.details.shipping_date).format('DD/MM/YYYY');
                    this.shippingDateInput = new Date(quote.details.shipping_date);
                }
                this.acceptedVehicleResult = true;
                return parsedQuote;
            },
            validateEffectiveDate() {
                if (!this.effectiveDateInput) return false;
                let date = this.moment(this.effectiveDateInput);

                this.assistanceAutocar.jour_prise_effet = date.format('D');
                this.assistanceAutocar.mois_prise_effet = date.format('M');
                this.assistanceAutocar.annee_prise_effet = date.format('YYYY');

                return true;
            },
            validateShippingDate() {
                if (!this.shippingDateInput) return false;
                let date = this.moment(this.shippingDateInput).format('DD/MM/YYYY');
                this.assistanceAutocar.shipping_date = date;
                return true;
            },
            resetEffectiveDate() {
                this.assistanceAutocar.jour_prise_effet = 1;
                this.assistanceAutocar.mois_prise_effet = 1;
                this.assistanceAutocar.annee_prise_effet = 1970;
            },
            cleanEffectiveDate() {
                this.assistanceAutocar.jour_prise_effet = '';
                this.assistanceAutocar.mois_prise_effet = '';
                this.assistanceAutocar.annee_prise_effet = '';
            },
            validateCirculationDate() {
                if (!this.circulationDateInput) return false;
                let date = this.moment(this.circulationDateInput);

                this.assistanceAutocar.jour_mise_en_circulation = date.format('D');
                this.assistanceAutocar.mois_mise_en_circulation = date.format('M');
                this.assistanceAutocar.annee_mise_en_circulation = date.format('YYYY');

                return true;
            },
            resetCirculationDate() {
                this.assistanceAutocar.jour_mise_en_circulation = '';
                this.assistanceAutocar.mois_mise_en_circulation = '';
                this.assistanceAutocar.annee_mise_en_circulation = '';
            },
            getListOfDurationOprions() {
                let list = [],
                    options = document.getElementById("durationSelect").options;

                for (let option of options) {
                    list.push(+option.value);
                }

                return list;

            },
            hasError(field) {
                return !!(this.errors.errors && this.errors.errors[field]);
            },
        },
        beforeRouteLeave(to, from, next) {
            this.assistanceAutocar = INITIAL_FIELDS_VALUES;
            next();
        },
        mounted() {
            if (this.$route.params.id) this.getGuarantyInfo();
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Garantie/BrokerAssistance/BrokerAssistanceAutocar.vue